import { create } from "zustand";
import { User } from "../types";
// import { AppUserSession } from "../services/user-session";
import { USER_TYPES } from "../constants";

interface AuthState {
  user: User | null;
  sessionInvalidated: boolean;
  setUser: (user: User | null) => void;
  restoreSession: (user: User) => void;
  resetUser: () => void;
  invalidateSession: () => void;
}

export const useAuthStore = create<AuthState>()((set) => ({
  user: null,
  sessionInvalidated: false,
  setUser: (user) => set(() => ({ user })),
  restoreSession: (user) =>
    set(() => ({
      user,
      sessionInvalidated: false,
    })),
  resetUser: () => set(() => ({ user: null })),
  invalidateSession: () =>
    set(() => ({
      user: null,
      sessionInvalidated: true,
    })),
}));

export function useAuth() {
  const { user, setUser, restoreSession, resetUser, sessionInvalidated } =
    useAuthStore();

  return {
    userInfo: user,
    isUserLogin: user?.account_type === USER_TYPES.USER,
    isTalentLogin: user?.account_type === USER_TYPES.TALENT,
    isOrganizationLogin: user?.account_type === USER_TYPES.ORGANIZATION,
    sessionInvalidated,
    setUser,
    restoreSession,
    resetUser,
  };
}
